import * as ss from 'superstruct';

const ArrayOrString = ss.union([ss.array(ss.string()), ss.string()]);

const mkProps = {
  email: ArrayOrString,
  phone: ArrayOrString,
  gen: ss.string(),
  doby: ss.string(),
  dobm: ss.string(),
  dobd: ss.string(),
  ln: ss.string(),
  fn: ss.string(),
  fi: ss.string(),
  ct: ss.string(),
  st: ss.string(),
  zip: ss.string(),
  country: ss.string(),
  extern_id: ss.string(),
  lead_id: ss.string(),
};

export const FacebookMatchKeyObj = ss.partial(mkProps);

export type FacebookMatchKeyObj = ss.Infer<typeof FacebookMatchKeyObj>;

export const FacebookMatchKeys = ss.enums(
  Object.keys(mkProps) as (keyof typeof mkProps)[],
);

export type FacebookMatchKeys = ss.Infer<typeof FacebookMatchKeys>;
